export default "__VITE_ASSET__CfVkDdwT__"